<template>
  <private-gym-page id="trainingen-page" name="home" :has_fab="true">

    <f7-block-title>
      Welkom {{ current_user.first_name }}!
    </f7-block-title>

    <training-sessions-list @newTraining="newTrainingSession"></training-sessions-list>

    <pg-fab @click="openActions = true" v-show="!openActions"></pg-fab>
    <f7-actions :opened="openActions" @actions:close="openActions = false">
      <f7-actions-group>
        <!--        <f7-actions-label>Do something</f7-actions-label>-->
        <f7-actions-button v-for="previous_training_session in last_4_training_sessions"
                           @click="copyTrainingSession(previous_training_session.id)">
          Kopieer {{ previous_training_session.name }} <small
          class="text-color-gray">{{ previous_training_session.start_date_day_half }}</small>
        </f7-actions-button>
      </f7-actions-group>
      <f7-actions-group>
        <f7-actions-button bold @click="newTrainingSession">
          Nieuwe Training
        </f7-actions-button>
      </f7-actions-group>
      <f7-actions-group>
        <f7-actions-button color="red">Cancel</f7-actions-button>
      </f7-actions-group>
    </f7-actions>

  </private-gym-page>
</template>

<script>

import TrainingSessionsList from "../components/training_sessions/TrainingSessionsList.vue";
import PageTopNavbar from "../components/nav/PageTopNavbar.vue";
import PrivateGymPage from "./_layouts/PrivateGymPage.vue";
import { f7, f7ready, theme } from 'framework7-vue';
import PgFab from "../components/general/PgFab.vue";

export default {
  components: {
    PgFab,
    PrivateGymPage,
    TrainingSessionsList,
    PageTopNavbar,
  },

  props: {
    f7route: Object,
    f7router: Object,
    has_fab: {default: false}
  },

  setup(props) {
    const { f7route, f7router } = props;
  },

  mixins: [],

  data: function () {
    return {
      openActions: false,
    };
  },

  computed: {
    current_user() {
      return this.$store.state.current_user.data;
    },
    is_logged_in() {
      return this.$store.getters['current_user/token'].length > 0;
    },
    last_4_training_sessions() {
      return this.$store.getters['training_sessions/training_sessions_reversed'](this.current_user.id).slice(0, 4);
    },
  },

  created() {
    //
  },

  mounted() {
    this.$store.dispatch('exercises/fetch_all');
  },

  methods: {
    newTrainingSession() {
      let vm = this;
      f7.dialog.prompt(
        null,
        'Naam van de Training?',
        vm.createTrainingSession,
      );
    },
    createTrainingSession(value) {
      this.$store.commit('app/show_loader');
      this.$store.dispatch('training_sessions/store', {
        name: value,
        user_id: this.current_user.id
      }).then(training_session => {
        this.$store.commit('app/hide_loader');
        this.f7router.navigate('/training-sessions/' + training_session.id + '/');
      });
    },
    copyTrainingSession(training_session_id) {
      this.$store.dispatch('current_user/copy_training_session', {training_session_id: training_session_id});
    }
  },

  watch: {
    //
  }
};
</script>
